/**
 * Utility for managing download-related window state
 * Provides a centralized interface for beforeunload listener state management
 *
 * Note: These functions perform side effects by mutating window properties.
 * This is necessary for coordinating beforeunload behavior across the application.
 * The mutations are contained within these utility functions to minimize scope.
 */

/**
 * Initialize window properties for download state tracking
 * Should be called once on DownloadManagerProvider mount
 */
export const initializeDownloadWindowState = () => {
  if (typeof window.__activeDownloadsCount === 'undefined') {
    window.__activeDownloadsCount = 0;
  }
  if (typeof window.__isExecutingDownload === 'undefined') {
    window.__isExecutingDownload = false;
  }
};

/**
 * Set the count of active downloads (pending/polling)
 */
export const setActiveDownloadsCount = (count: number) => {
  window.__activeDownloadsCount = count;
};

/**
 * Get the count of active downloads (pending/polling)
 */
export const getActiveDownloadsCount = (): number => {
  return window.__activeDownloadsCount ?? 0;
};

/**
 * Set flag indicating a download is currently being executed (anchor.click)
 */
export const setIsExecutingDownload = (isExecuting: boolean) => {
  window.__isExecutingDownload = isExecuting;
};

/**
 * Get flag indicating if a download is currently being executed
 */
export const getIsExecutingDownload = (): boolean => {
  return window.__isExecutingDownload ?? false;
};
